(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('.current-variant-title').forEach((el) => {
      const pos = parseInt(el.dataset.optionPosition, 10) - 1;
      if (variant.options[pos]) {
        el.textContent = variant.options[pos];
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
